import React, { Component } from 'react'
import anime from 'animejs'
import './CodeIcon.css'
import DownArrow from '../DownArrow/DownArrow';



class CodeIcon extends Component {
    
    componentDidMount() {
        anime({
            targets: '.codeIcon .symbol path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 3000,
            delay: 1500,
            direction: 'alternate',
            loop: false
            });
        // 
        // Functions to position letters
        // 
        anime({
            targets: '.codeIcon #letterN path',
            translateY: 50,
            scale: 1.25,
            duration: 500
        });
        anime({
            targets: '.codeIcon #letterJ path',
            easing: 'easeInOutSine',
            translateY: 140,
            translateX: 140,
            scale: 1.25,
            duration: 500
        });
        anime({
            targets: '.codeIcon #letterC path',
            easing: 'easeInOutSine',
            translateY: 235,
            translateX: 300,
            scale: 1.25,
            duration: 500
        });
        // 
        // Functions for path tracing/reveal of letters and code icon
        // 
        anime({
            targets: '.codeIcon #letterN path, .codeIcon #letterN circle',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 3000,
            delay: 3000,
            direction: 'alternate',
            loop: false
        });
        anime({
            targets: '.codeIcon #letterJ path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            height: 400,
            duration: 3000,
            delay: 4000,
            direction: 'alternate',
            loop: false
        });
        anime({
            targets: '.codeIcon #letterC path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 3000,
            delay: 5000,
            direction: 'alternate',
            loop: false,
            
        });
        // 
        // Functions to reveal fills for letters and code icon
        // 
        // anime({
        //     targets: ".codeIcon .symbol path",
        //     delay: 7000,
        //     duration: 2000,
        //     fillOpacity: 1,
        //     easing: "easeInSine"
        // });
        anime({
            targets: 'codeIcon #letterN path',
            stroke: 'rgb(0,0,0)',
            delay: 7000
        })
        anime({
            targets: ".codeIcon #letterN path",
            delay: 6000,
            duration: 1000,
            fillOpacity: 1,
            easing: "easeInQuint",
            offset: 150
        }); 
        anime({
            targets: ".codeIcon #letterJ path",
            delay: 6250,
            fillOpacity: 1,
            easing: "easeInQuint"
        }); 
        anime({
            targets: ".codeIcon #letterC path",
            delay: 6500,
            fillOpacity: 1,
            easing: "easeInQuint"
        }); 


    // anime({
    //     targets: '#codeIcon .lines path',
    //     fill: [
    //         {value: 'rgb(255,51,51)'},
    //         {value: 'rgb(255,128,0)'},
    //         {value: 'rgb(255,255,0)'},
    //         {value: 'rgb(128,255,0)'},
    //         {value: 'rgb(0,255,255)'},
    //         {value: 'rgb(0,128,255)'},
    //         {value: 'rgb(0,0,255)'},
    //         {value: 'rgb(127,0,255)'},
    //         {value: 'rgb(255,0,255)'},
    //         {value: 'rgb(255,0,127)'},
    //     ],
    //     easing: 'linear',
    //     direction: 'alternate',
    //     duration: 4000,
    //     loop: true
    // })
}

        render() {
            return (
                <div className="icon">
                {/* <Initials/> */}
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className="codeIcon" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="616.001px" height="612.001px" viewBox="0 0 612.001 612.001" styles="enable-background:new 0 0 612.001 612.001;"
                xmlSpace="preserve">
                <g fill="" fillRule="evenodd" stroke="" strokeWidth="5" className="lines symbol">
                    <path d="M599.751,276.341L489.037,165.537c-7.924-7.924-18.451-12.288-29.65-12.288c-11.179,0-21.699,4.352-29.627,12.261
                    c-16.334,16.33-16.342,42.932-0.008,59.296l81.083,81.165l-81.079,81.109c-7.928,7.932-12.287,18.475-12.279,29.688
                    c0.007,11.191,4.37,21.707,12.283,29.594c7.92,7.92,18.444,12.279,29.639,12.279c11.202,0,21.729-4.359,29.639-12.279
                    l110.714-110.752C616.085,319.269,616.085,292.679,599.751,276.341z M589.092,324.962L478.378,435.714
                    c-5.068,5.072-11.809,7.865-18.979,7.865c-7.17,0-13.911-2.793-18.986-7.873c-5.068-5.053-7.856-11.777-7.864-18.945
                    c-0.008-7.178,2.788-13.934,7.867-19.016l86.399-86.438c2.943-2.943,2.943-7.713,0.004-10.652l-86.399-86.49
                    c-10.463-10.486-10.467-27.532-0.011-37.984c5.079-5.064,11.82-7.853,18.979-7.853c7.17,0,13.915,2.796,18.99,7.871
                    l110.714,110.805C599.552,297.465,599.552,314.492,589.092,324.962z" />
                    <path d="M194.525,416.773c0.007-11.209-4.348-21.748-12.28-29.688l-81.075-81.109l81.09-81.173
                    c16.323-16.364,16.312-42.962-0.034-59.304c-7.92-7.897-18.437-12.246-29.612-12.246c-11.198,0-21.73,4.363-29.654,12.288
                    L12.25,276.334c-16.334,16.345-16.334,42.939,0.004,59.281l110.703,110.74c7.917,7.928,18.448,12.291,29.646,12.291
                    s21.722-4.355,29.62-12.264C190.147,438.484,194.518,427.968,194.525,416.773z M171.571,435.718
                    c-5.06,5.068-11.797,7.857-18.968,7.857s-13.915-2.793-18.987-7.871L22.914,324.962c-10.464-10.467-10.464-27.501,0-37.969
                    L133.62,176.196c5.079-5.075,11.824-7.871,18.994-7.871c7.159,0,13.896,2.785,18.964,7.837
                    c10.467,10.463,10.471,27.51,0.015,37.992l-86.407,86.494c-2.939,2.939-2.939,7.708,0.004,10.652l86.399,86.434
                    c5.079,5.086,7.875,11.842,7.867,19.021C179.446,423.925,176.654,430.654,171.571,435.718z" />
                    <path d="M410.932,23.764c-4.726-1.76-9.657-2.653-14.665-2.653c-17.435,0-33.203,10.987-39.244,27.333l-180.595,485.89
                    c-3.918,10.502-3.508,21.9,1.165,32.104c4.668,10.191,13.014,17.939,23.482,21.801c4.725,1.76,9.653,2.652,14.646,2.652
                    c17.416,0,33.207-10.982,39.304-27.336L435.642,77.608C443.652,55.919,432.56,31.763,410.932,23.764z M421.504,72.37
                    L240.897,558.294c-3.907,10.479-14.024,17.521-25.177,17.521c-3.191,0-6.349-0.574-9.401-1.711
                    c-6.699-2.477-12.035-7.432-15.022-13.949c-2.992-6.529-3.256-13.828-0.739-20.562L371.156,53.681
                    c3.866-10.467,13.957-17.499,25.11-17.499c3.206,0,6.363,0.573,9.416,1.711C419.537,43.014,426.636,58.489,421.504,72.37z" />
                </g>
                <g fill="none" fillRule="evenodd" id="letterN" stroke="rgba(0,0,0,.6)" strokeWidth="3" className="lines initials">   
                    <path fill="" d="M158,196.1c-8.3,0-14.1-2.9-17.2-8.5l-28-51v48.7c0,2.5-0.9,5.9-5.3,8.3c-3,1.6-6.6,2.5-10.7,2.5
                        c-4.1,0-7.7-0.8-10.7-2.5c-4.3-2.4-5.3-5.8-5.3-8.3V76.1c0-2.5,0.9-5.9,5.3-8.3c3-1.6,6.6-2.5,10.7-2.5c5.7,0,9.8,0.8,12.7,2.6
                        c2.9,1.8,5.9,5.7,9.3,12.2l23.1,44.1V75.9c0-2.5,0.9-6,5.3-8.2c3-1.6,6.6-2.3,10.6-2.3c4.1,0,7.6,0.8,10.6,2.3
                        c4.4,2.3,5.3,5.7,5.3,8.2v109.4c0,2.5-0.9,5.9-5.3,8.3C165.7,195.2,162.1,196.1,158,196.1z M110.4,124.3c0.9,0,1.7,0.5,2.2,1.3
                        l32.7,59.5c2.2,4,6.4,5.9,12.8,5.9c3.2,0,6-0.6,8.3-1.8c2.3-1.3,2.7-2.8,2.7-3.9V75.9c0-1.1-0.3-2.6-2.6-3.8
                        c-2.3-1.2-5.1-1.8-8.3-1.8c-3.2,0-6,0.6-8.3,1.8c-2.3,1.2-2.6,2.7-2.6,3.8v58.5c0,1.2-0.8,2.2-1.9,2.4c-1.1,0.3-2.3-0.2-2.8-1.3
                        l-27.9-53.1c-3.6-6.9-6-9.3-7.4-10.2c-2.1-1.2-5.5-1.9-10.1-1.9c-3.2,0-6,0.6-8.3,1.8c-2.3,1.3-2.7,2.8-2.7,3.9v109.2
                        c0,1.2,0.3,2.6,2.6,3.9c2.3,1.2,5,1.8,8.3,1.8c3.2,0,6-0.6,8.3-1.8c2.3-1.3,2.6-2.8,2.6-3.9v-58.5c0-1.1,0.8-2.1,1.9-2.4
                        C110,124.3,110.2,124.3,110.4,124.3z"/>
                    <circle fill="none" cx="53.5" cy="166.1" r="2.7"/>
                    <path fill="none" d="M117.3,213.3V213c0-1.5-1.2-2.6-2.6-2.6h-4.5v-4.5c0-1.5-1.2-2.6-2.6-2.6h-0.2c-1.5,0-2.6,1.2-2.6,2.6v4.5
                        h-4.5c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h4.5v4.5c0,1.5,1.2,2.6,2.6,2.6h0.2c1.5,0,2.6-1.2,2.6-2.6v-4.5h4.5
                        C116.1,215.9,117.3,214.7,117.3,213.3z"/>
                    <path fill="none" d="M53.5,157.8c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2S58.1,157.8,53.5,157.8z
                        M53.5,168.8c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7S55,168.8,53.5,168.8z"/>
                    <path fill="none" d="M73.5,111v-0.2c0-1.5-1.2-2.6-2.6-2.6H23.3c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h47.5
                        C72.3,113.6,73.5,112.4,73.5,111z"/>
                    <path fill="none" d="M56.9,98.5h6.4c1.5,0,2.6-1.2,2.6-2.6v-0.2c0-1.5-1.2-2.6-2.6-2.6h-6.4c-1.5,0-2.6,1.2-2.6,2.6v0.2
                        C54.3,97.3,55.4,98.5,56.9,98.5z"/>
                    <path fill="none" d="M42.5,122.5c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h9.1c1.5,0,2.6-1.2,2.6-2.6v-0.2
                        c0-1.5-1.2-2.6-2.6-2.6H42.5z"/>
                    <path fill="none" d="M112.6,139.5L112.6,139.5c0-1.3-0.9-2.4-2.2-2.6v5.2C111.6,141.9,112.6,140.8,112.6,139.5z"/>
                    </g>
                        <g fill="none" fillRule="evenodd" stroke="rgba(0,0,0,.6)" id="letterJ" strokeWidth="3" className="lines initials letterJ"> 
                    <path fill="" d="M124.6,197.1c-13.1,0-24.1-3.4-32.6-10.2c-8.7-6.9-13.1-16.4-13.1-28.3c0-5.7,1.3-9.7,4-12
                        c2.6-2.2,6.5-3.3,12.1-3.3c12.3,0,15.3,5.6,15.7,10.4c0.2,2.3,0.5,4.1,0.7,5.4c0.2,1.2,0.8,2.8,1.7,4.8c0.7,1.6,1.8,2.7,3.4,3.5
                        c1.8,0.9,4.1,1.3,6.9,1.3c9,0,13.2-4.7,13.2-14.7V93.7h-12.5c-3.4,0-6.2-1.6-8.1-4.6c-1.7-2.7-2.5-6-2.5-9.8c0-3.5,0.8-6.7,2.4-9.4
                        c1.8-3,4.7-4.7,8.2-4.7h30.1c3.7,0,6.9,0.9,9.6,2.5c3,1.9,4.6,4.7,4.6,8.2V154c0,14.7-4.1,25.7-12.3,32.7
                        C148,193.6,137.4,197.1,124.6,197.1z M95,148.4c-5.3,0-7.8,1.1-8.9,2.1c-1.5,1.3-2.2,4.1-2.2,8.2c0,10.4,3.7,18.4,11.2,24.4
                        c7.6,6,17.5,9.1,29.5,9.1c11.6,0,21.1-3.1,28.2-9.2c7-6,10.6-15.7,10.6-28.9V76.1c0-1.8-0.7-3-2.3-4c-1.9-1.2-4.2-1.8-6.9-1.8h-30.1
                        c-1.8,0-3,0.7-3.9,2.2c-1.1,1.9-1.7,4.1-1.7,6.8c0,2.8,0.6,5.2,1.8,7.1c1,1.6,2.2,2.3,3.8,2.3h15c1.4,0,2.5,1.1,2.5,2.5V154
                        c0,16.3-9.9,19.7-18.2,19.7c-3.6,0-6.6-0.6-9.1-1.8c-2.7-1.3-4.6-3.3-5.8-6c-1-2.3-1.6-4.2-2-5.7c-0.3-1.5-0.6-3.4-0.8-5.9
                        C105.6,152.6,105.3,148.4,95,148.4z"/>
                    <path fill="none"  d="M226,118h-4.3c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h4.3c1.5,0,2.6-1.2,2.6-2.6v-0.2
                        C228.6,119.2,227.5,118,226,118z"/>
                    <path fill="none"  d="M165.9,123.5h32.7c1.5,0,2.6-1.2,2.6-2.6v-0.2c0-1.5-1.2-2.6-2.6-2.6h-32.7V123.5z"/>
                    <path fill="none"  d="M191,102.9h-6.4c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h6.4c1.5,0,2.6-1.2,2.6-2.6v-0.2
                        C193.7,104.1,192.5,102.9,191,102.9z"/>
                    <path fill="none"  d="M182,135c0-1.5-1.2-2.6-2.6-2.6h-9.1c-1.5,0-2.6,1.2-2.6,2.6v0.2c0,1.5,1.2,2.6,2.6,2.6h9.1
                        c1.5,0,2.6-1.2,2.6-2.6V135z"/>
                    <path fill="none"  d="M237.7,146.8c-1.5,0-2.6,1.2-2.6,2.6v0c0,1.5,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6v0
                        C240.3,148,239.1,146.8,237.7,146.8z"/>
                        </g>
                        <g fill="none" fillRule="evenodd" stroke="rgba(0,0,0,.6)" strokeWidth="3" id="letterC" className="lines initials"> 
                        <path fill="none" d="M23.4,107.3h4.3c1.5,0,2.6-1.2,2.6-2.6v-0.2c0-1.5-1.2-2.6-2.6-2.6h-4.3c-1.5,0-2.6,1.2-2.6,2.6v0.2
                            C20.7,106.1,21.9,107.3,23.4,107.3z"/>
                        <path fill="none" d="M50.8,107.3h36.3c0-1.9,0.1-3.7,0.3-5.5H50.8c-1.5,0-2.6,1.2-2.6,2.6v0.2C48.2,106.1,49.4,107.3,50.8,107.3z
                            "/>
                        <path fill="none" d="M58.4,92.2h6.4c1.5,0,2.6-1.2,2.6-2.6v-0.2c0-1.5-1.2-2.6-2.6-2.6h-6.4c-1.5,0-2.6,1.2-2.6,2.6v0.2
                            C55.7,91,56.9,92.2,58.4,92.2z"/>
                        <path fill="none" d="M79.1,121.7c1.5,0,2.6-1.2,2.6-2.6v-0.2c0-1.5-1.2-2.6-2.6-2.6H70c-1.5,0-2.6,1.2-2.6,2.6v0.2
                            c0,1.5,1.2,2.6,2.6,2.6H79.1z"/>
                        <path fill="" d="M128.4,197.1c-12.8,0-23.4-3.5-31.5-10.4c-8.2-7-12.3-18-12.3-32.7v-45.6c0-14.7,4.1-25.7,12.3-32.7
                            c8.1-6.9,18.6-10.4,31.5-10.4c13.1,0,24.1,3.2,32.5,9.6c8.7,6.5,13.1,15.7,13.1,27.1c0,5.8-1.3,9.7-4,12c-2.6,2.2-6.5,3.3-12,3.3
                            c-12.6,0-15.6-5.7-15.9-10.4c-0.3-9.1-4.3-13.1-12.8-13.1c-8.9,0-13,4.7-13,14.7V154c0,10,4.2,14.7,13.2,14.7c2.8,0,5.1-0.4,6.9-1.3
                            c1.6-0.8,2.7-1.9,3.4-3.5c0.8-2,1.4-3.6,1.7-4.8c0.3-1.3,0.5-3.1,0.7-5.4c0.4-4.7,3.5-10.3,15.7-10.3c5.6,0,9.6,1.1,12.1,3.3
                            c2.7,2.3,4,6.2,4,12c0,11.9-4.4,21.4-13.1,28.3C152.5,193.7,141.5,197.1,128.4,197.1z M128.4,70.3c-11.6,0-21.1,3.1-28.2,9.2
                            c-7,6-10.6,15.7-10.6,28.9V154c0,13.2,3.6,22.9,10.6,28.9c7.1,6.1,16.6,9.2,28.2,9.2c12,0,21.9-3.1,29.5-9.1
                            c7.5-6,11.2-13.9,11.2-24.4c0-4.1-0.8-6.9-2.2-8.2c-1.1-0.9-3.5-2.1-8.9-2.1c-10.3,0-10.6,4.2-10.8,5.8c-0.2,2.6-0.5,4.5-0.8,6
                            c-0.3,1.6-1,3.4-2,5.7c-1.2,2.7-3.1,4.7-5.8,6c-2.5,1.2-5.5,1.8-9.1,1.8c-8.3,0-18.2-3.4-18.2-19.7v-45.6c0-16.3,9.8-19.7,18-19.7
                            c11.3,0,17.4,6.2,17.8,17.9c0.1,1.5,0.4,5.7,10.9,5.7c4.1,0,7.1-0.7,8.7-2.1c1.5-1.3,2.2-4.1,2.2-8.2c0-9.9-3.6-17.5-11.1-23.1
                            C150.3,73.2,140.4,70.3,128.4,70.3z"/>
                        <path fill="none" d="M14.3,133.2L14.3,133.2c0-1.5-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6v0c0,1.5,1.2,2.6,2.6,2.6
                            S14.3,134.7,14.3,133.2z"/>
                </g>
            </svg>
            {/* <h1>Full Stack Web Developer</h1> */}
            <DownArrow/>
        </div>
            )
        }
}
    



export default CodeIcon;


// WEBPACK FOOTER //
// ./src/components/CodeIcon/CodeIcon.js